const activeEnv = process.env.GATSBY_ACTIVE_ENV || "us"
const isFrance = activeEnv === "fr"

export const BASE_PATH_PRODUCT = isFrance ? "/produit/" : "/product/"
export const BASE_PATH_ENGAGEMENT = isFrance
  ? "/bague-de-fiancailles/"
  : "/engagement-rings/"

const BASE_PATH_BLOG = "/blog/"

function getProductLink(slug) {
  return BASE_PATH_PRODUCT + slug + "/"
}

function getEngagementLink(slug) {
  return BASE_PATH_ENGAGEMENT + slug + "/"
}

function getBespokeLink() {
  let link = isFrance
    ? "/bague-de-fiancailles-service-sur-mesure/"
    : "/bespoke-engagement-ring/"
  return link
}
function getEngagementPlpLink(color) {
  const materialHandles = {
    "yellow gold": isFrance ? "or-jaune" : "yellow-gold",
    "rose gold": isFrance ? "or-rose" : "rose-gold",
    "white gold": isFrance ? "or-blanc" : "white-gold",
  }

  let materialHandle

  if (color) {
    materialHandle = materialHandles[color]
  }

  let link = isFrance ? `bague-de-fiancailles/` : "engagement-rings/"

  if (materialHandle) {
    link = materialHandle + "-" + link
  }

  return "/" + link
}

function getWeddingLink() {
  let link = isFrance ? "/alliances-pour-elle/" : "/wedding-bands-for-her/"

  return link
}

function getArticleLink(slug) {
  return BASE_PATH_BLOG + slug + "/"
}

function getIsVisibleInLocale(locale) {
  if (!locale) return false

  const activeEnv = process.env.GATSBY_ACTIVE_ENV || "us"
  const currentLocal = activeEnv === "staging" ? "us" : activeEnv
  const currentLocalCapitalized = currentLocal.toUpperCase()

  return locale.includes(currentLocalCapitalized)
}

function getLearnPageLink(slug, categorySlug) {
  return `/learn/${categorySlug}/${slug}`
}

function getLearnCategoryLink(categorySlug) {
  return `/learn/${categorySlug}/`
}

function getProductLinkByMaterial(slug, color, createdAt, nonJewelry) {
  const formattedColor = color?.toLowerCase() || "yellow gold"
  const materialHandles = {
    "yellow gold": isFrance ? "or-jaune" : "yellow-gold",
    "rose gold": isFrance ? "or-rose" : "rose-gold",
    "white gold": isFrance ? "or-blanc" : "white-gold",
    "yellow gold & white gold": isFrance
      ? "or-jaune-or-blanc"
      : "yellow-gold-white-gold",
    "white gold & rose gold": isFrance
      ? "or-blanc-or-rose"
      : "white-gold-rose-gold",
    "yellow gold & rose gold": isFrance
      ? "or-jaune-or-rose"
      : "yellow-gold-rose-gold",
    "white gold & yellow gold": isFrance
      ? "or-blanc-or-jaune"
      : "white-gold-yellow-gold",
    "rose gold & yellow gold": isFrance
      ? "or-rose-or-jaune"
      : "rose-gold-yellow-gold",
    platinum: "platinum",
  }

  const createdDate = new Date(createdAt)
  const pdpUpdatedDate = new Date("2022-09-01")

  const materialHandle = materialHandles[formattedColor]

  let link = `${BASE_PATH_PRODUCT}${materialHandle}-${slug}/`

  if (createdDate < pdpUpdatedDate && formattedColor === "yellow gold") {
    link = `${BASE_PATH_PRODUCT}${slug}/`
  }

  if (nonJewelry) {
    link = `${BASE_PATH_PRODUCT}${slug}/`
  }

  return link
}

export {
  getProductLink,
  getEngagementLink,
  getBespokeLink,
  getEngagementPlpLink,
  getWeddingLink,
  getArticleLink,
  getLearnPageLink,
  getIsVisibleInLocale,
  getLearnCategoryLink,
  getProductLinkByMaterial,
}
